module.exports = __webpack_public_path__ + "img/btn-arrow-down-g.8fa1966b.svg";